const COLORS = {
  PRIMARY: "primary",
  GHOST: "ghost",
  PINK: 'pink',
  SILVER: 'silver',
  GOLD: 'gold',
  BASIC: 'basic',
  NAV_PILL: 'navPill',
  MAOR_WEBSITE: 'maorWebsite',
};

const SIZES = {
  XS: "xs",
  S: "s",
  M: "m",
  XL: "xl",
  ASM: "asm",
};

export { COLORS, SIZES };
